import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiErrorMessage } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const processed = useRef(false);
  const { setSessionUser, refresh } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      try {
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
          navigate("/");
          return;
        }
        const session_id = m[1];
        const tenant_slug = sessionStorage.getItem("mr_pending_tenant_slug") || null;
        sessionStorage.removeItem("mr_pending_tenant_slug");

        const { data } = await api.post("/auth/google/session", { session_id, tenant_slug });
        setSessionUser(data.token, data.user);
        // Clear hash and route based on role
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        if (data.user.role === "patient" && tenant_slug) {
          navigate(`/c/${tenant_slug}/dashboard`);
        } else if (data.user.role === "admin" || data.user.role === "staff") {
          navigate("/admin");
        } else if (data.user.role === "super_admin") {
          navigate("/super-admin");
        } else {
          navigate("/");
        }
      } catch (e) {
        toast.error(apiErrorMessage(e, "Google sign-in failed"));
        navigate("/");
      }
    })();
  }, [navigate, setSessionUser, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-mr-bg">
      <p className="text-mr-secondary">Completing sign-in…</p>
    </div>
  );
}
